require('../../fhApp/currentUser/currentUser');
require('../../fhApp/appMetaService');
require('../../fhApp/hostnameMatchService');

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuService', [
  'app.currentUser',
  'app.appMetaService',
  'app.hostnameMatchService'
])
  .factory('app.mainFrame.sidebarMenu.sidebarMenuService', [
    '$state',
    'currentUser',
    'appMetaService',
    'hostnameMatchService',
    'PRODUCT',
    function ($state, currentUser, appMeta, hostnameMatchService, product) {

      let items = [];

      let init = function () {

        items = [
          {
            label: 'Home',
            action: function () {
              $state.go('app.home', null, { inherit: false, reload: true });
            },
            state: 'app.home',
            icon: 'fa fa-home'
          }
        ];

        let access = currentUser.data.access;
        if (access && Array.isArray(access)) {
          access.sort();

          let used_functions = [];
          let used_function_ids = [];
          let prefix = 'func-';

          for (let i = 0; i < access.length; i++) {
            let access_item = access[i];
            let key = prefix + access_item.iaccessfunctionid_fk;

            if (used_functions.hasOwnProperty(key)) {
              continue;
            }

            if (used_function_ids.indexOf(access_item.iaccessfunctionid_fk) !== -1) {
              continue;
            }

            used_function_ids.push(access_item.iaccessfunctionid_fk);

            switch (access_item.iaccessfunctionid_fk) {
              case 100:
                used_functions.push(
                  {
                    label: 'Roster Manager',
                    action: function () {
                      $state.go('app.admin.rosters', null, { inherit: false, reload: true });
                    },
                    state: 'app.admin.rosters'
                  }
                );
                break;
              case 101:
                used_functions.push({
                  label: "Reporting",
                  icon: "fa fa-file-excel-o",
                  action: function () {
                    $state.go('app.admin.reports', null, { inherit: false, reload: true })
                  },
                  state: 'app.admin.reports'
                });
                break;
              case 102:
                used_functions.push({
                  label: "Team Manager",
                  icon: "fa fa-users",
                  action: function () {
                    $state.go('app.admin.teamInfoManager', null, { inherit: false, reload: true });
                  },
                  state: 'app.admin.teamInfoManager'
                });
                break;
              case 200:
                used_functions.push({
                  label: "Syndication",
                  icon: "fa fa-clone",
                  action: function () {
                    let url = hostnameMatchService.base_url(null, 'https:');
                    window.open(
                      url + '/popup/syndication',
                      'syndication_popup',
                      "height=700,width=1000"
                    );
                    // $state.go('app.admin.syndication', null, {inherit: false, reload: true});
                  },
                  // state: 'app.admin.syndication'
                });
                break;
              case 2:
                used_functions.push({
                  label: "Video Analysis",
                  //icon: "fa fa-clone",
                  action: function () {
                    $state.go('app.admin.videoAnalysis.myClips', null, { inherit: false, reload: true });
                  },
                  state: 'app.admin.videoAnalysis.myClips'
                });
            }
          }

          if (used_functions.length) {
            items.push(
              {
                label: 'Admin Controls',
                action: function () {
                  return false;
                },
                state: 'app.admin',
                icon: 'fa fa-bar-chart-o',
                children: used_functions
              }
            )
          }
        }

        let menuItems = getMenuByProductName();
        if (Array.isArray(menuItems)) {
          for (let i = 0; i < menuItems.length; i++) {
            items.push(menuItems[i])
          }
        }
      };

      let getMenuByProductName = () => {
        switch (product.Code) {
          case "ahl":
            return [
              {
                label: 'Subscribe',
                action: function () {
                  $state.go('app.pricing', null, { inherit: false, reload: true });
                },
                state: 'app.pricing',
                icon: 'fa fa-dollar'
              },
              {
                label: 'Redeem Code',
                action: function () {
                  $state.go('app.redeemPromo', null, { inherit: false, reload: true });
                },
                state: 'app.redeemPromo',
                icon: 'fa fa-gift'
              },
              {
                label: 'Schedule',
                action: function () {
                  $state.go('app.schedule', null, { inherit: false, reload: true });
                },
                state: 'app.schedule',
                icon: 'fa fa-calendar'
              },
              {
                label: 'My ' + product.Name,
                action: function () {
                  return false;
                },
                icon: 'fa fa-user',
                state: 'app.myHockeyTv',
                children: [
                  {
                    label: 'My Feed',
                    action: function () {
                      $state.go('app.myHockeyTv.myFeed', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myFeed'
                  },
                  {
                    label: 'My Games',
                    action: function () {
                      $state.go('app.myHockeyTv.myGames', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myGames'
                  },
                  {
                    label: 'My Clips',
                    action: function () {
                      $state.go('app.myHockeyTv.myClips', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myClips'
                  },
                  {
                    label: 'Following/Followers',
                    action: function () {
                      $state.go('app.myHockeyTv.followersFollowing', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.followersFollowing'
                  },
                  {
                    label: 'Upcoming schedule',
                    action: function () {
                      $state.go('app.myHockeyTv.upcomingSchedule', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.upcomingSchedule'
                  },
                  {
                    label: 'Watch Clips',
                    action: function () {
                      $state.go('app.myHockeyTv.watchClips', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.watchClips',
                    icon: 'fa fa-certificate'
                  }
                ]
              },
              {
                label: 'Favorites',
                action: function () {
                  $state.go('app.favorites', null, { inherit: false, reload: true });
                },
                state: 'app.favorites',
                icon: 'fa fa-star'
              },
              {
                label: 'Support',
                action: function () {
                  window.open(appMeta.supportSite);
                },
                icon: 'fa fa-question-circle'
              },
              {
                label: 'How To Watch',
                action: function () {
                  $state.go('app.howToWatch', null, { inherit: false, reload: true });
                },
                state: 'app.howToWatch',
                icon: 'fa fa-tv'
              },
              {
                label: 'Info Center',
                action: function () {
                  return false;
                },
                icon: 'fa fa-info-circle',
                state: 'app.information',
                children: [
                  {
                    label: 'About',
                    action: function () {
                      $state.go('app.information.about', null, { inherit: false, reload: true });
                    },
                    state: 'app.information.about'
                  },
                  {
                    label: 'Terms',
                    action: function () {
                      $state.go('app.information.terms', null, { inherit: false, reload: true });
                    },
                    state: ['app.information.terms', {}]
                  },
                  {
                    label: 'Privacy',
                    action: function () {
                      $state.go('app.information.privacy', null, { inherit: false, reload: true });
                    },
                    state: ['app.information.privacy', {}]
                  },
                  {
                    label: 'FAQ',
                    action: function () {
                      $state.go('app.information.faq', null, { inherit: false, reload: true });
                    },
                    state: 'app.information.faq'
                  }
                ]
              },
            ];

          default:
            return [
              {
                label: 'Schedule',
                action: function () {
                  $state.go('app.schedule', null, { inherit: false, reload: true });
                },
                state: 'app.schedule',
                icon: 'fa fa-calendar'
              },
              {
                label: 'My ' + product.Name,
                action: function () {
                  return false;
                },
                icon: 'fa fa-user',
                state: 'app.myHockeyTv',
                children: [
                  {
                    label: 'My Feed',
                    action: function () {
                      $state.go('app.myHockeyTv.myFeed', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myFeed'
                  },
                  {
                    label: 'My Games',
                    action: function () {
                      $state.go('app.myHockeyTv.myGames', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myGames'
                  },
                  {
                    label: 'My Clips',
                    action: function () {
                      $state.go('app.myHockeyTv.myClips', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.myClips'
                  },
                  {
                    label: 'Following/Followers',
                    action: function () {
                      $state.go('app.myHockeyTv.followersFollowing', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.followersFollowing'
                  },
                  {
                    label: 'Upcoming schedule',
                    action: function () {
                      $state.go('app.myHockeyTv.upcomingSchedule', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.upcomingSchedule'
                  },
                  {
                    label: 'Watch Clips',
                    action: function () {
                      $state.go('app.myHockeyTv.watchClips', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.watchClips',
                    icon: 'fa fa-certificate'
                  },
                  {
                    label: 'College Commitments',
                    action: function () {
                      $state.go('app.myHockeyTv.collegeCommitments', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.collegeCommitments'
                  },
                  {
                    label: 'Manage Reminders',
                    action: function () {
                      $state.go('app.myHockeyTv.manageReminders', {}, { reload: true });
                    },
                    state: 'app.myHockeyTv.manageReminders'
                  }
                ]
              },
              {
                label: 'Favorites',
                action: function () {
                  $state.go('app.favorites', null, { inherit: false, reload: true });
                },
                state: 'app.favorites',
                icon: 'fa fa-star'
              },
              {
                label: 'Channels',
                action: function () {
                  $state.go('app.coverage.channels', null, { inherit: false, reload: true })
                },
                state: 'app.coverage.channels',
                icon: 'fa fa-th'
              },
              {
                label: 'Events',
                action: function () {
                  $state.go('app.coverage.events', null, { inherit: false, reload: true });
                },
                state: 'app.coverage.events',
                icon: 'fa fa-trophy'
              },
              {
                label: 'Games of the week',
                action: function () {
                  $state.go('app.gotw', null, { inherit: false, reload: true });
                },
                state: 'app.gotw',
                icon: 'fa fa-bullseye'
              },
              {
                label: 'Pricing',
                action: function () {
                  $state.go('app.pricing', null, { inherit: false, reload: true });
                },
                state: 'app.pricing',
                icon: 'fa fa-dollar'
              },
              {
                label: 'Redeem Code',
                action: function () {
                  $state.go('app.redeemPromo', null, { inherit: false, reload: true });
                },
                state: 'app.redeemPromo',
                icon: 'fa fa-gift'
              },
              {
                label: 'Support',
                action: function () {
                  window.open(appMeta.supportSite);
                },
                icon: 'fa fa-question-circle'
              },
              {
                label: 'Info Center',
                action: function () {
                  return false;
                },
                icon: 'fa fa-info-circle',
                state: 'app.information',
                children: [
                  {
                    label: 'About',
                    action: function () {
                      $state.go('app.information.about', null, { inherit: false, reload: true });
                    },
                    state: 'app.information.about'
                  },
                  {
                    label: 'Terms',
                    action: function () {
                      $state.go('app.information.terms', null, { inherit: false, reload: true });
                    },
                    state: ['app.information.terms', {}]
                  },
                  {
                    label: 'Privacy',
                    action: function () {
                      $state.go('app.information.privacy', null, { inherit: false, reload: true });
                    },
                    state: ['app.information.privacy', {}]
                  },
                  {
                    label: 'FAQ',
                    action: function () {
                      $state.go('app.information.faq', null, { inherit: false, reload: true });
                    },
                    state: 'app.information.faq'
                  }
                ]
              },
            ];
        }
      };

      init();

      let service = {
        items: items,

        reinit: function () {
          init();
          service.items = items;
        },

        manageExpanded: function (item, items) {
          if (item.expanded) {
            item.expanded = false;
          } else {
            for (let i = 0; i < items.length; i++) {
              items[i].expanded = false;
            }
            item.expanded = true;
          }
        },

        isItemActive: function (item, exact) {
          if (item.state) {
            let match_state = null;
            let match_state_params = null;

            if (Array.isArray(item.state)) {
              match_state = item.state[0];

              if (item.state[1]) {
                match_state_params = item.state[1];
              }
            }
            else {
              match_state = item.state;
              match_state_params = null;
            }

            if (exact) {
              return $state.is(match_state, match_state_params);
            }
            else {
              return $state.includes(match_state, match_state_params);
            }
          }
          return false;
        }
      };

      return service;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/sidebarMenu/sidebarMenuService.js